import { PersonsSearchService_personsSearchServiceV2PostSearch } from '@festina/legalentity-general-types/legalentity/hooks/PersonsSearchService_personsSearchServiceV2PostSearch'

export const usePersonAdvancedSearch =
  PersonsSearchService_personsSearchServiceV2PostSearch.useLazyQuery
